"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getArrowOpenCssClass = exports.getActiveButtonCssClass = exports.KeyDownUtil = exports.KeyUpUtil = exports.handleToggleUtil = void 0;
const styles = __importStar(require("./MultiSelectComboBoxFilter.css"));
const handleToggleUtil = (props, keyRef) => {
    const { disabled, expanded, handleToggle } = props;
    if (!disabled) {
        handleToggle();
        if (!expanded) {
            // @ts-ignore
            keyRef.current.focus();
        }
    }
};
exports.handleToggleUtil = handleToggleUtil;
const KeyUpUtil = (e, props, handleToggle) => {
    const { expanded, handleSelected, selectedIndex } = props;
    if (expanded) {
        switch (e.keyCode) {
            case 9:
                handleSelected(-1);
                break;
            case 32:
                e.preventDefault();
                if (selectedIndex === -1) {
                    handleToggle();
                }
                break;
        }
    }
};
exports.KeyUpUtil = KeyUpUtil;
const KeyDownUtil = (e, props, handleToggle) => {
    const { expanded, selectedIndex, options, handleSelected, handleCheckBoxChange, handleCancel } = props;
    let prevent = false;
    if (expanded) {
        switch (e.keyCode) {
            // down
            case 40:
                prevent = true;
                handleSelected(selectedIndex + 1);
                break;
            // up
            case 38:
                prevent = true;
                handleSelected(selectedIndex - 1);
                break;
            // space
            case 32:
                prevent = true;
                if (selectedIndex > -1 && !options[selectedIndex].disabled) {
                    handleCheckBoxChange(options[selectedIndex].key, !options[selectedIndex].checked);
                }
                break;
            // tab
            case 9:
                prevent = false;
                handleSelected(-1);
                break;
            // esc
            case 27:
                handleCancel();
                handleToggle();
                prevent = true;
                break;
        }
    }
    if (prevent) {
        e.preventDefault();
    }
};
exports.KeyDownUtil = KeyDownUtil;
const getActiveButtonCssClass = (values, componentClassName) => values.length === 0 ? '' : `${styles.multiSelectBtnActive} ${componentClassName}-button-active`;
exports.getActiveButtonCssClass = getActiveButtonCssClass;
const getArrowOpenCssClass = (expanded) => (expanded ? `${styles.arrowOpen} arrowOpen` : '');
exports.getArrowOpenCssClass = getArrowOpenCssClass;
